export default {
  cardTitle: 'Set table card style',
  cardDocTitle: 'Seat card',
  infoTitle: 'Print seat information',
  infoLoadFailed: 'Failed to load seat information. Please try again.',
  printTableTab: 'Print seat table',
  printMapTab: 'Print seat map',
  withNames: 'Show names',
  withoutNames: 'Hide names',
  mapHint: 'Full A4 venue frame with the venue, stage, and all seats. Seat numbers are shown when names are hidden.',
  downloadPng: 'Download PNG',
  mapUnavailable: 'No seat map is available for this venue',
  mapDownloaded: 'Seat map generated',
  mapDownloadFailed: 'Failed to generate the seat map. Please try again.',
  printTable: 'Print seat table',
  printMap: 'Print seat map',
  styleTab: '1. Table card style',
  printTab: '2. Preview and print',
  styleTitle: 'Seat unit table card settings',
  styleMode: 'Table card style',
  styleModeUniform: 'Uniform style',
  styleModeSeparate: 'Separate styles',
  styleModeHint: 'Set a style for each seat unit. Switching to uniform style applies the current unit style to all seat units.',
  styleModeUniformHint: 'Uniform style applies the current unit style to every seat unit and replaces their existing styles.',
  styleUnit: 'Select seat unit',
  styleUnitPlaceholder: 'Select a seat unit',
  styleNoUnits: 'The current layout has no seat unit available for table cards.',
  styleDone: 'Done',
  styleNext: 'Next: preview and print',
  goStyle: 'Set table card style',
  cardSaveFailed: 'Failed to save the table card style. Please try again.',
  cardUnitsEmpty: 'No seat unit in the current layout has seat cards enabled.',
  cardUnitsEmptyHint: 'Enable seat cards for the units you want to print in "1. Table card style", then come back to print.',
  cardUnits: 'Units with seat cards enabled',
  content: 'Print content',
  backgroundOnly: 'Card background only',
  backgroundPerson: 'Background + selected information',
  cardCount: '{count} cards will be printed',
  cardPreviewSummary: 'Will print {count} {kind} · Print style preview',
  cardKindBackground: 'background-only seat cards',
  cardKindPerson: 'seat cards with selected information',
  unassignedHint: 'No person is assigned in the selected units. Choose "Card background only" to preview and print backgrounds.',
  blankCardHint: 'No background image is set. The printed card will be blank.',
  previewReady: 'Seat card preview generated. Choose "Browser print preview" to inspect the full layout, or click "Print" to open browser printing.',
  sheets: 'sheets',
  printerTitle: 'Select printer',
  printerLocationUnknown: 'Location unavailable',
  online: 'Online',
  offline: 'Offline',
  noPrinters: 'No printer detected. You can still use browser printing or save as PDF.',
  browserPreview: 'Browser print preview',
  print: 'Print',
  printFailed: 'Printing failed. Please try again.',
  printSettingsHint: 'In the browser print panel, turn off headers and footers and choose the paper size that matches the seat cards.',
  infoTable: 'Seat information table',
  infoFullTitle: 'Seat information',
  infoCount: '{count} assigned seats',
  infoStats: '{total} seats · {assigned} assigned · {empty} empty · {reserved} reserved · {pending} unassigned',
  activityLabel: 'Activity',
  sessionLabel: 'Session',
  venueLabel: 'Venue',
  unboundActivity: 'No activity bound',
  noSession: 'No session selected',
  currentVenue: 'Current venue',
  index: 'No.',
  unit: 'Seat unit',
  seatPosition: 'Row / Column',
  seatPositionValue: 'Row {row}, column {column}',
  seatNo: 'Seat',
  person: 'Name',
  jobTitle: 'Job title',
  organization: 'Organization',
  status: 'Status',
  statusAssigned: 'Assigned',
  statusReserved: 'Reserved',
  statusEmpty: 'Empty',
  viewFullTable: 'View full table',
  downloadTable: 'Download CSV'
}
